import { formatDate } from "hooks";
import React from "react";

const DateWidget = ({ date1, date2 }) => {
  return (
    <div className="flex flex-col font-medium text-[14px]">
      <span>{formatDate(date1)}</span>
      {date2 && <span>{formatDate(date2)}</span>}
    </div>
  );
};

export default DateWidget;
